import { NewsMixpanelEvents } from '../../constants/mixpanel-events';
import type { ArticleMetadata } from '../getArticleMetadata/getArticleMetadata';
import { track } from '$global/utils/track';

export type ArticleReadSection = 'view' | 'article' | 'newsletter';

export const trackArticleRead = ({
	articleId,
	section,
	metadata,
}: {
	articleId: string;
	section: ArticleReadSection;
	metadata: ArticleMetadata;
}) => {
	track(NewsMixpanelEvents.ArticleRead, {
		article_id: articleId,
		section,
		...metadata,
	});
};
